import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=261a20d0&scoped=true&"
import script from "./Canvas.vue?vue&type=script&lang=js&"
export * from "./Canvas.vue?vue&type=script&lang=js&"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=261a20d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a20d0",
  null
  
)

export default component.exports